import { Component, DestroyRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { SolPreferencesService } from '../../../../../services/preferences/sol-preferences.service';
import { DropDownItem } from '../../../../../models/dtos';
import { ISolPreferencesEstimatorFormGroup } from '../../../../../models/preferences/ISolPreferencesEstimatorFormGroup';
import { CommonMetaDataService } from '../../../../../services/common-meta-data.service';

@Component({
  selector: 'app-sol-preferences-estimator',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    TranslatePipe
  ],
  templateUrl: './sol-preferences-estimator.component.html',
  styleUrls: ['./sol-preferences-estimator.component.scss']
})
export class SolPreferencesEstimatorComponent implements OnInit {
  estimatorForm!: FormGroup<ISolPreferencesEstimatorFormGroup>;
  userTypes: DropDownItem[] = [];

  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly preferencesService: SolPreferencesService,
    private readonly destroyRef: DestroyRef,
    private readonly commonMetaDataService: CommonMetaDataService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    const preferences = this.preferencesService.getUserPreferences()?.preferences;
   
    this.userTypes = this.commonMetaDataService.getMetaData()?.userTypes ?? [];

    this.estimatorForm = this.fb.group<ISolPreferencesEstimatorFormGroup>({
      name: this.fb.control<string>(preferences?.salesPersonName ?? ''),
      emailAddress: this.fb.control<string>(preferences?.salesPersonEmail ?? '', { validators: Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) }),
      userType: this.fb.control<number | null>(preferences?.userType ?? null)
    });
  }

  // removing sync from subscription. this should be called only when the user leaves the field.
  syncToService(): void { 
    const value = this.estimatorForm.value;
    this.preferencesService.silentSetPreferences(data => {
      data.preferences.salesPersonName = value.name ?? '';
      data.preferences.salesPersonEmail = value.emailAddress ?? '';
      data.preferences.userType = value.userType ?? null;
    });
  }

  onBlur(): void {
    this.updateEmailIfInvalid();
    this.syncToService();
  }

  private updateEmailIfInvalid(): void {
    const emailControl = this.estimatorForm.controls.emailAddress;
    if(emailControl.dirty && (emailControl.value === '' || !emailControl.valid)){
      const lastSavedEmail = this.preferencesService.getUserPreferences()?.preferences.salesPersonEmail ?? '';
      this.estimatorForm.controls.emailAddress.setValue(lastSavedEmail);
    }
  }
}
